import { createPortal } from 'react-dom'
import Popup from '../popup/Popup'

interface IProps {
  title: string | React.ReactNode
  message: string | React.ReactNode
  status: 'error' | 'warning' | 'success'
  icon?: React.ReactNode
  width?: number
  isOpen: boolean
  okText?: string
  cancelText?: string
  onOk: () => void
  onCancel?: () => void
}

const PopupPortal = ({
  title,
  message,
  isOpen,
  icon,
  onOk,
  onCancel,
  okText = 'ยืนยัน',
  cancelText = 'ยกเลิก',
  status = 'success',
  width = 400,
}: IProps) => {
  return (
    <>
      {isOpen &&
        createPortal(
          <Popup
            title={title}
            message={message}
            isOpen={isOpen}
            icon={icon}
            okText={okText}
            onOk={onOk}
            cancelText={cancelText}
            onCancel={onCancel}
            status={status}
            width={width}
          />,
          document.body,
        )}
    </>
  )
}
export default PopupPortal
